import { Quote } from "lucide-react";
import { Reveal } from "../lib/anim";

export const Partner = () => (
  <section id="partner" data-testid="partner" className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
    {/* Founder */}
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <div className="aspect-square rounded-[2rem] overflow-hidden shadow-xl">
            <img src="/photo-doctor.webp" alt="Amaan Jabrani with a Lifeline Primary Care physician" className="w-full h-full object-cover" />
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="lg:col-span-7">
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-brand-blue font-bold mb-4">The Founder</p>
        <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-brand-ink leading-tight">
          Led by a next generation of healers.
        </h2>
        <p className="mt-6 text-lg text-brand-ink/65 leading-relaxed">
          AMCares was founded by <span className="text-brand-ink font-semibold">Amaan Jabrani</span> — an Eagle Scout, rising
          senior at Innovation Academy, and future healthcare professional. Amaan has volunteered ~200 hours at Grady Hospital,
          shadowed physicians, served with Food4Lives in downtown Atlanta, and organized Red Cross blood drives.
        </p>
        <p className="mt-4 text-lg text-brand-ink/65 leading-relaxed">
          As Vice President of Doctors Without Borders and Treasurer of Mind Matters at his school, he channels a commitment to
          prevention, education, and compassionate care into practical solutions for real communities.
        </p>
      </Reveal>
    </div>

    {/* Lifeline partnership */}
    <Reveal delay={0.05}>
      <div className="mt-20 md:mt-28 bg-brand-ink text-white rounded-[2rem] p-10 md:p-16 relative overflow-hidden">
        <div className="relative z-10 flex flex-col lg:flex-row lg:items-center gap-10">
          <div className="shrink-0">
            <p className="text-xs uppercase tracking-[0.2em] text-brand-sky font-bold mb-4">In Partnership With</p>
            <div className="bg-white rounded-full p-3 w-40 h-40 flex items-center justify-center shadow-lg">
              <img src="/lifeline-logo.png" alt="Lifeline Primary Care" className="w-full h-full object-contain rounded-full" />
            </div>
          </div>
          <div>
            <Quote className="h-10 w-10 text-brand-green mb-6" />
            <p className="font-display text-2xl md:text-4xl leading-snug max-w-3xl text-balance">
              Alongside <span className="text-brand-sky">Lifeline Primary Care</span>, AMCares delivers hygiene kits and health
              education directly through a trusted clinical setting — supporting patients well beyond their visit.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <span className="h-px w-12 bg-brand-green" />
              <span className="text-white/60 text-sm uppercase tracking-widest">A student-led healthcare initiative</span>
            </div>
          </div>
        </div>
        <div className="absolute -bottom-24 -right-16 w-80 h-80 rounded-full bg-brand-blue/25 blur-3xl" />
      </div>
    </Reveal>
  </section>
);
